/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AdminTemplateFileType {
    SURVEY = 'survey',
    BC_LEVEL_MAPPING = 'bcLevelMapping',
    SURVEY_JOB_PROFILE = 'surveyJobProfile',
    MODULE_JOB = 'moduleJob',
    SURVEY_JOB_MAPPING = 'surveyJobMapping',
    SURVEY_JOB_ROLLUP = 'surveyJobRollup',
    VENDOR_LEVEL_PROFILE = 'vendorLevelProfile',
    SURVEY_TENANT = 'surveyTenant',
}
